export type IconProps = {
    linkedIcon?: {
        url?: string;
        size?: IconSize;
        alt?: string;
        paddingIncluded?: boolean;
    };
    iconComponent?: JSX.Element;
};

export type IconSize = "x-small" | "small" | "medium" | "large";

export const iconSizesPaddingExcluded: Record<IconSize, number> = {
    "x-small": 24,
    "small": 32,
    "medium": 48,
    "large": 64
};

export const iconSizesPaddingIncluded: Record<IconSize, number> = {
    "x-small": 32,
    "small": 48,
    "medium": 88,
    "large": 128
};
